import type { DayPanelEntry } from "@jackedlogs/shared";

// WHICH exercise the editor has open, as something that survives a redraw.
//
// ⛔ An index does not. `buildDayPanel` skips every block with no placement on
// the day (programDayPanel.ts:260) and then SORTS what is left (:278), so the
// entries array is not a stable address: remove the open exercise's last
// active week on the day you are looking at — which PE-22 F's hold makes a
// one-gesture move — and it drops out of the list while every later entry
// slides up one. Reopening by index then silently loads a DIFFERENT exercise.
//
// Identity is the members' exercise ids: a block that SPLITS (a non-rectangular
// placement) still merges back into one entry under the same key, so the split
// case — the one the reopen was written for — keeps matching.
export const entryIdentity = (entry: DayPanelEntry): string =>
  entry.kind === "composed"
    ? entry.members.map((m) => m.exerciseId).join("+")
    : entry.exerciseId;

/** -1 when the entry is no longer on this day — the caller must close the
 *  editor rather than open whatever took its place. */
export const findEntryIndex = (
  entries: DayPanelEntry[],
  identity: string,
): number => entries.findIndex((e) => entryIdentity(e) === identity);
